<template>
  <div>
    <!-- Footer -->
    <div class="container">
      <footer id="footer"
              class="footer text-center collapse fixed-bottom"
        >
        <div class="row no-gutters">
          <!-- Footer Location -->
          <div class="col-lg-4 mb-5 mb-lg-0 h-100">
            <h4 class="mb-4">Contact</h4>
            <div class="row justify-content-center">
              <p class="lead mb-0 ml-2">Warandelaan 2 | 5027 AB Tilburg
                <br>013-4662865
                <br><a href="mailto:brabant@tilburguniversity.edu" class="text-white">brabant@tilburguniversity.edu</a>
                <br><a href="http://www.brabantcollectie.nl" target="_blank" class="text-white">www.brabantcollectie.nl</a>
              </p>
            </div>
          </div>

          <!-- Footer Social Media -->
          <div class="col-lg-4 mb-5 mb-lg-0">
            <h4 class="mb-4">Social Media</h4>
            <a class="btn btn-outline-light btn-social mx-1" href="https://brabant-collectie.blogspot.com/"
               target="_blank">
              <i class="fab fa-fw fa-blogger"></i>
            </a>
            <a class="btn btn-outline-light btn-social mx-1" href="https://www.facebook.com/brabantcollectie.nl"
               target="_blank">
              <i class="fab fa-fw fa-facebook-f"></i>
            </a>
            <a class="btn btn-outline-light btn-social mx-1" href="https://twitter.com/BC1837" target="_blank">
              <i class="fab fa-fw fa-twitter"></i>
            </a>
            <a class="btn btn-outline-light btn-social mx-1" href="https://www.youtube.com/user/Brabantcollectie"
               target="_blank">
              <i class="fab fa-fw fa-youtube"></i>
            </a>
            <a class="btn btn-outline-light btn-social mx-1" href="https://www.flickr.com/photos/brabantcollectie/"
               target="_blank">
              <i class="fab fa-fw fa-flickr"></i>
            </a>
            <p class="mt-4">
              <small>Copyright &copy; Brabant-Collectie <span id="copyright-year">{{ fullYear }}</span></small>
            </p>
          </div>

          <!-- Footer Accountability Text -->
          <div class="col-lg-4 mb-5 mb-lg-0">
            <h4 class="mb-4">Verantwoording</h4>
            <div class="row justify-content-center">
              <p class="lead align-right mb-0 ml-2"><a href="/disclaimer" target="_blank">Disclaimer</a>
                <br><a href="/copyright" target="_blank">Copyright</a>
                <br>
                <router-link to="/privacy" target="_blank">Privacy</router-link>
                <br><a href="/cookies" target="_blank">Cookies</a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>

    <!-- Collapsed Footer -->
    <div id="footer-button-collapse"
         class="collapsed footer-collapsed"
         :class="{ 'element-hide-bottom': isMobile && scrollDown, 'element-show-bottom': isMobile && scrollUp }"
         data-toggle="collapse"
         data-target="#footer">
      <div class="text-center">
        Contact en informatie<i class="fa fa-chevron-down"></i>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Footer',
  data() {
    return {
      isMobile: false,
      scrollUp: false,
      scrollDown: false,
      lastScrollPosition: 0,
      fullYear: new Date().getFullYear()
    }
  },
  methods: {
    onScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 0) {
        return
      }

      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) === 0) {
        return
      }

      this.scrollDown = currentScrollPosition > this.lastScrollPosition
      this.scrollUp = currentScrollPosition < this.lastScrollPosition

      let w = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
      this.isMobile = w < 992;
      this.lastScrollPosition = currentScrollPosition
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style lang="scss">
@import "../scss/base/annimations";
@import "../scss/components/footer";
</style>
